export const thresholdKeys = [
  'carbonDioxide',
  'sulphurDioxide',
  'butane',
  'temperature'
]

export const thresholdHeaders = {
  vital: 'Ambient Values',
  lowest_tresh_hold: 'Lowest Threshold Value',
  highest_tresh_hold: 'Highest Threshold Value',
  time_frame: 'Time Frame',
  data_point: 'Data Point',
  rate_of_change: 'Rate of change',
  empty: ''
}

export const getAgeRanges = () => ([
  {
    min: 0,
    max: 18
  },
  {
    min: 19,
    max: 30
  },
  {
    min: 31,
    max: 40
  },
  {
    min: 41,
    max: 50
  },
  {
    min: 51,
    max: 60
  },
  {
    min: 61,
    max: 70
  },
  {
    min: 71,
    max: 80
  },
  {
    min: 81,
    max: 200
  }
])

export const ageRangeOptions = () => ([
  { label: '0-18', value: '0-18', selected: false },
  { label: '19-30', value: '19-30', selected: false },
  { label: '31-40', value: '31-40', selected: false },
  { label: '41-50', value: '41-50', selected: false },
  { label: '51-60', value: '51-60', selected: false },
  { label: '61-70', value: '61-70', selected: false },
  { label: '71-80', value: '71-80', selected: false },
  { label: '81+', value: '81-200', selected: false }
])

export const vitalPlaceholders = {
  sulphurDioxide: {
    key: 'SD',
    vital: 'Sulphur Dioxide (SD)'
  },
  carbonDioxide: {
    key: 'CD',
    vital: 'Carbon Dioxide (CD)'
  },
  butane: {
    key: 'BU',
    vital: 'Butane (BU)'
  },
  temperature: {
    key: 'TEMP',
    vital: 'Temperature (TEMP)'
  }
}

export const reverseMapVital = {
  SD: 'sulphurDioxide',
  CD: 'carbonDioxide',
  BU: 'butane',
  TEMP: 'temperature'
}

export const getDefaultVitalInfo = () => ({
  roc: 0,
  min: 0,
  max: 0,
  time_frame: 0,
  previous_events: 0,
  is_included: false
})
